'use strict';

var Content = require('./src/Content.js');
var Dialog$1 = require('./src/Dialog.js');
var Footer = require('./src/Footer.js');
var Header = require('./src/Header.js');

const Dialog = Dialog$1.Dialog;
Dialog.Header = Header.Header;
Dialog.Footer = Footer.Footer;
Dialog.Content = Content.Content;

exports.Dialog = Dialog;
//# sourceMappingURL=index.js.map
